import CfECom from './CfECom'

export * from './typings'

export default CfECom
